export default __webpack_public_path__ + "static/media/options.1b5d8787.svg";